import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import SignIn from "./pages/SignIn";
/*import AssignedTaskTimer from "./pages/AssignedTaskTimer";*/
import Timer from "./pages/Timer";
import Report from "./pages/Report";
import GeolocationAuth from "./components/GeolocationAuth";
import FormTeam from "./pages/FormTeam";
import AssignTask from './pages/AssignTask';
import AddUser from "./pages/AddUser";
import ApplyLeave from './pages/ApplyLeave'; // Import ApplyLeave page
import ApproveLeave from "./pages/LeaveApproval";
import { useUserContext } from './context/UserContext'; 
import { isAuthenticated } from "./utils/sessionCheck"; // Import necessary session checks
import AssignCoordinates from "./pages/AssignCoordinates";
import AssignTimer from "./pages/Assigntimer";
import SelectTenant from "./pages/SelectTenant"; // Import SelectTenant page
import UserManagement from "./pages/UserManagement"; // Import UserManagement page
// Remove this import as it conflicts with the local variable
import TenantManagement from "./pages/TenantManagement"; // <-- Add this line
import TimerManagement from "./pages/TimerManagement"; // Import TimerManagement page
import AdminQREvent from "./pages/AdminQREvent";
import EventManagement from "./pages/EventManagement";
import ClassroomManagement from "./pages/ClassroomManagement";
import QRScan from "./pages/QRScan";
import Dashboard from "./pages/Dashboard";
import Timetable from "./pages/Timetable";
import ExternalAttendance from "./pages/ExternalAttendance";
import SupervisorManagement from "./pages/SupervisorManagement";
import TimeBookingApproval from "./pages/TimeBookingApproval";
import Footer from "./components/Footer";
import Legal from "./pages/Legal";
import PrivacyPolicy from "./pages/PrivacyPolicy";


function App() {
  const { userId, userRole, tenantId } = useUserContext();
  const authenticated = isAuthenticated(); // Check if the user is authenticated
  
  // Check if user is admin or SuperAdmin
  const isAdmin = userRole === "admin" || userRole === "SuperAdmin";

  // Show loading state while context is being initialized
  if (!userRole && authenticated) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column'
      }}>
        <div>Loading...</div>
        <div>Please wait while we initialize your session</div>
      </div>
    );
  }

  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SignIn />} />
          <Route
            path="/dashboard"
            element={
              authenticated ? <Dashboard /> : <Navigate to="/" />
            }
          />
          
          {/* Protect /timer route */}
          <Route
            path="/timer"
            element={
              authenticated ? (
                // Timer should be accessible without blocking UI; it enforces checks internally
                <Timer />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/assigntimer"
            element={
              authenticated ? (
                <AssignTimer />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          
          {/* Protect /report route */}
          <Route
            path="/report"
            element={
              authenticated ? <Report /> : <Navigate to="/" /> // Redirect to SignIn if not authenticated
            }
          />

          {/* QR Scan - any authenticated user */}
          <Route
            path="/scan"
            element={
              authenticated ? <QRScan /> : <Navigate to="/" />
            }
          />
          {/* External Attendance - for users scanning QR outside the app */}
          <Route
            path="/external-attendance"
            element={<ExternalAttendance />}
          />
          {/* Timetable - visible to all authenticated users */}
          <Route
            path="/timetable"
            element={
              authenticated ? <Timetable /> : <Navigate to="/" />
            }
          />
          <Route
            path="/timetable/:classroomId"
            element={
              authenticated ? <Timetable /> : <Navigate to="/" />
            }
          />
          
          {/* Time Booking Approval - Available to supervisors and admins */}
          <Route 
            path="/time-booking-approval" 
            element={
              authenticated ? <TimeBookingApproval /> : <Navigate to="/" />
            } 
          />
          <Route path="/legal" element={<Legal />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          {/* Protect admin routes */}
          {isAdmin && (
            <>
              <Route path="/formteam" element={<FormTeam />} />
              <Route path="/assign" element={<AssignCoordinates />} />
              <Route path="/task" element={<AssignTask />} />
              <Route path="/adduser" element={<AddUser />} />
              
              {/* Leave Approval - Only for Admins */}
              <Route path="/leaveapproval" element={<ApproveLeave />} />
              
              {/* Timer Management - Only for Admins */}
              <Route path="/timermanagement" element={<TimerManagement />} />

              {/* Admin QR Event creation */}
              <Route path="/qr-event" element={<AdminQREvent />} />
              <Route path="/event-management" element={<EventManagement />} />
              <Route path="/classrooms" element={<ClassroomManagement />} />
              
              {/* Supervisor Management - Only for Admins */}
              <Route path="/supervisor-management" element={<SupervisorManagement />} />
            </>
          )}
          
          {/* {(userRole === "SuperAdmin" || userRole === "admin") && ( */}
            <Route path="/usermanagement" element={<UserManagement />} />
          {/* )} */}

          {userRole === "SuperAdmin" && (
            <Route path="/tenantmanagement" element={<TenantManagement />} />
          )}

          {/* Protect Apply Leave route for all authenticated users */}
          <Route
            path="/applyleave"
            element={
              authenticated ? <ApplyLeave /> : <Navigate to="/" /> // Redirect to SignIn if not authenticated
            }
          />
          <Route path="/select-tenant" element={<SelectTenant />} />
        </Routes>
        {authenticated && <Footer />}
      </BrowserRouter>
    </div>
  );
}

export default App;
